/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PaginatedSellerBookingList } from '../model';
/**
 * SellerBookingApi - axios parameter creator
 * @export
 */
export const SellerBookingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Paginated list of<br /> - Accepted Bookings - Incoming/Outgoing Confirmations - Incoming/Outgoing Data Requests  That the authenticated User is associated with.  Ordered from oldest to newest  # Filters  ## past  Valid values: 0, 1  Default: 0  When 0: Bookings with a date from today and into the future will be returned.  When 1: Bookings with dates set before today will be returned. 
         * @summary List of Bookings
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {boolean} [past] Default: 0&lt;br /&gt;When 0: Bookings with a date from today and into the future will be returned.&lt;br /&gt;When 1: Bookings with dates set before today will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBookingList: async (aaSource?: string, page?: number, pageSize?: number, past?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (past !== undefined) {
                localVarQueryParameter['past'] = past;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellerBookingApi - functional programming interface
 * @export
 */
export const SellerBookingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellerBookingApiAxiosParamCreator(configuration)
    return {
        /**
         * Paginated list of<br /> - Accepted Bookings - Incoming/Outgoing Confirmations - Incoming/Outgoing Data Requests  That the authenticated User is associated with.  Ordered from oldest to newest  # Filters  ## past  Valid values: 0, 1  Default: 0  When 0: Bookings with a date from today and into the future will be returned.  When 1: Bookings with dates set before today will be returned. 
         * @summary List of Bookings
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {boolean} [past] Default: 0&lt;br /&gt;When 0: Bookings with a date from today and into the future will be returned.&lt;br /&gt;When 1: Bookings with dates set before today will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerBookingList(aaSource?: string, page?: number, pageSize?: number, past?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSellerBookingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerBookingList(aaSource, page, pageSize, past, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SellerBookingApi - factory interface
 * @export
 */
export const SellerBookingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellerBookingApiFp(configuration)
    return {
        /**
         * Paginated list of<br /> - Accepted Bookings - Incoming/Outgoing Confirmations - Incoming/Outgoing Data Requests  That the authenticated User is associated with.  Ordered from oldest to newest  # Filters  ## past  Valid values: 0, 1  Default: 0  When 0: Bookings with a date from today and into the future will be returned.  When 1: Bookings with dates set before today will be returned. 
         * @summary List of Bookings
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {boolean} [past] Default: 0&lt;br /&gt;When 0: Bookings with a date from today and into the future will be returned.&lt;br /&gt;When 1: Bookings with dates set before today will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBookingList(aaSource?: string, page?: number, pageSize?: number, past?: boolean, options?: any): AxiosPromise<PaginatedSellerBookingList> {
            return localVarFp.sellerBookingList(aaSource, page, pageSize, past, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerBookingList operation in SellerBookingApi.
 * @export
 * @interface SellerBookingApiSellerBookingListRequest
 */
export interface SellerBookingApiSellerBookingListRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerBookingApiSellerBookingList
     */
    readonly aaSource?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof SellerBookingApiSellerBookingList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof SellerBookingApiSellerBookingList
     */
    readonly pageSize?: number

    /**
     * Default: 0&lt;br /&gt;When 0: Bookings with a date from today and into the future will be returned.&lt;br /&gt;When 1: Bookings with dates set before today will be returned.
     * @type {boolean}
     * @memberof SellerBookingApiSellerBookingList
     */
    readonly past?: boolean
}

/**
 * SellerBookingApi - object-oriented interface
 * @export
 * @class SellerBookingApi
 * @extends {BaseAPI}
 */
export class SellerBookingApi extends BaseAPI {
    /**
     * Paginated list of<br /> - Accepted Bookings - Incoming/Outgoing Confirmations - Incoming/Outgoing Data Requests  That the authenticated User is associated with.  Ordered from oldest to newest  # Filters  ## past  Valid values: 0, 1  Default: 0  When 0: Bookings with a date from today and into the future will be returned.  When 1: Bookings with dates set before today will be returned. 
     * @summary List of Bookings
     * @param {SellerBookingApiSellerBookingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerBookingApi
     */
    public sellerBookingList(requestParameters: SellerBookingApiSellerBookingListRequest = {}, options?: any) {
        return SellerBookingApiFp(this.configuration).sellerBookingList(requestParameters.aaSource, requestParameters.page, requestParameters.pageSize, requestParameters.past, options).then((request) => request(this.axios, this.basePath));
    }
}
